if (!customElements.get('m-accordion')) {
  customElements.define(
    'm-accordion',
    class MAccordion extends HTMLElement {
      constructor() {
        super();
        this.items = [];
        this.itemEvents = [];
        this.duration = 280;
      }

      connectedCallback() {
        this.disconnectItems();
        this.items = Array.from(this.querySelectorAll('[data-m-accordion-item], [data-m-faq-item]'));
        this.items.forEach((item) => {
          const toggle = this.getToggle(item);
          const panel = this.getPanel(item);

          if (!toggle || !panel) return;

          const onClick = () => this.toggleItem(item);
          toggle.addEventListener('click', onClick);
          this.itemEvents.push({ toggle, onClick });

          if (item.classList.contains('is-open')) {
            this.openItem(item, false);
          } else {
            this.closeItem(item, false);
          }
        });
      }

      toggleItem(item) {
        if (item.classList.contains('is-open')) {
          this.closeItem(item);
          return;
        }

        this.items.forEach((currentItem) => {
          if (currentItem !== item && currentItem.classList.contains('is-open')) {
            this.closeItem(currentItem);
          }
        });

        this.openItem(item);
      }

      openItem(item, animate = true) {
        const toggle = this.getToggle(item);
        const panel = this.getPanel(item);

        if (!toggle || !panel) return;

        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel.style.visibility = 'visible';

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.style.height = 'auto';
          panel.style.transition = '';
          return;
        }

        panel.style.transition = '';
        panel.style.height = '0px';

        requestAnimationFrame(() => {
          panel.style.transition = `height ${this.duration}ms ease`;
          panel.style.height = `${panel.scrollHeight}px`;
        });

        this.afterTransition(panel, () => {
          if (item.classList.contains('is-open')) {
            panel.style.height = 'auto';
            panel.style.transition = '';
          }
        });
      }

      closeItem(item, animate = true) {
        const toggle = this.getToggle(item);
        const panel = this.getPanel(item);

        if (!toggle || !panel) return;
        if (animate && !item.classList.contains('is-open')) return;

        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.style.height = '0px';
          panel.style.visibility = 'hidden';
          panel.style.transition = '';
          return;
        }

        panel.style.transition = '';
        panel.style.height = `${panel.scrollHeight}px`;

        requestAnimationFrame(() => {
          panel.style.transition = `height ${this.duration}ms ease`;
          panel.style.height = '0px';
        });

        this.afterTransition(panel, () => {
          if (!item.classList.contains('is-open')) {
            panel.style.visibility = 'hidden';
            panel.style.transition = '';
          }
        });
      }

      afterTransition(panel, callback) {
        const onTransitionEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;

          panel.removeEventListener('transitionend', onTransitionEnd);
          callback();
        };

        panel.addEventListener('transitionend', onTransitionEnd);
      }

      getToggle(item) {
        return item.querySelector('[data-m-accordion-toggle], [data-m-faq-toggle]');
      }

      getPanel(item) {
        return item.querySelector('[data-m-accordion-panel], [data-m-faq-panel]');
      }

      disconnectItems() {
        this.itemEvents.forEach(({ toggle, onClick }) => {
          toggle.removeEventListener('click', onClick);
        });
        this.itemEvents = [];
      }

      disconnectedCallback() {
        this.disconnectItems();
      }
    },
  );
}
